import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      years: formatMessage(messages.years),
    };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
